import { store } from '@store/store'
import {
  NotificationType,
  notificationActionCreators,
} from '@storeOld/reducers/notification'
import { put, select } from 'redux-saga/effects'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { authSelector } from '@/hooks/useAuth'
import type { AuthState } from '@/types'
import { upgradeModal } from '../upgradeModal'

export function* alert() {
  const { planId }: AuthState = yield select(authSelector)

  sendGtmEvent(GtmTriggerName.UPGRADE_PROJECT)

  const modal = upgradeModal(planId, 'projects')

  yield put(
    notificationActionCreators.setNotification({
      type: NotificationType.LIMIT_REACHED,
      // No next plan (Team, Agency) — nothing to link the toast to.
      ...(modal && {
        actionText: 'Upgrade',
        callback: () => store.dispatch(modal),
      }),
    })
  )

  if (modal) {
    yield put(modal)
  }
}
